import apiClient from "./axios.config";

const ListPropertyServices ={
  postPropertylisting(payload) {
    return apiClient.post("/website/list-property", payload);
  },
}
export default ListPropertyServices;